import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable, of } from "rxjs";
import { environment } from "../../environments/environment";
import { AuthenticationService } from "../../shared/services/authentication.service";
import { ILesson } from "../models/lesson.model";

@Injectable()
export class LessonService {
    lessons$!: Observable<ILesson[]>;
    newLesson$!: Observable<ILesson>;
    createdLesson!: ILesson;

    private http = inject(HttpClient);
    private authService = inject(AuthenticationService);
    
    getLessons(): Observable<ILesson[]> {
        const token = this.authService.getUserToken();
        let options = { headers: new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }) };

        if (token) {
            return this.http.get<ILesson[]>(environment.API_URL + '/api/Lesson/', options);
        } else {
            return of([]);
        }
    }

    getLesson(id: string): Observable<ILesson> {
        const token = this.authService.getUserToken();
        let options = { headers: new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }) };

        if (token) {
            return this.http.get<ILesson>(environment.API_URL + `/api/Lesson/ById/${id}`, options);
        } else {
            return of();
        }
    }

    deleteLesson(id: string): Observable<ILesson> {
        const token = this.authService.getUserToken();
        let options = { headers: new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }) };

        let params = {
            id: id
        }; 

        if (token) {
            return this.http.post<ILesson>(environment.API_URL + `/api/Lesson/delete`, params, options);
        } else {
            return of();
        }
    }

    createLesson(lesson: ILesson): Observable<ILesson> {
        const token = this.authService.getUserToken();
        let options = { headers: new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }) };

        if (token) {
            return this.http.post<ILesson>(environment.API_URL + '/api/Lesson/create', lesson, options);
        } else {
            return of();
        }
    }

    editLesson(lesson: ILesson): Observable<ILesson> {
        const token = this.authService.getUserToken();
        let options = { headers: new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }) };

        if (token) {
            return this.http.post<ILesson>(environment.API_URL + '/api/Lesson/update', lesson, options);
        } else {
            return of();
        }
    }

    getNextOrder(): Observable<number> {
        const token = this.authService.getUserToken();

        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        if (token !== undefined && token !== null && token !== '') {
            return this.http.get<number>( environment.API_URL + `/api/lesson/getNextOrder`, options);
        } else {
            return of();
        }    
    }      
}
